import { Helmet } from "react-helmet";
import * as Constants from '../../../Common/Constants'

const ContactMeta = () => {

    return (
        <Helmet>
            <title>Contact Augnito | Discover the Perfect Solution for Your Clinical Requirements</title>
            <link rel="shortcut icon" href={Constants.SITE_URL + "/favicon.ico"} />
            <link rel="icon" href={Constants.SITE_URL + "/favicon.ico"} />
            <link rel="profile" href="https://gmpg.org/xfn/11" />
            <meta name="description" content="Get expert support for Augnito's medical speech to text software. Reach out for inquiries, or assistance with our AI-powered healthcare dictation solutions." />
            <link rel="canonical" href={Constants.SITE_URL + "/contact-us"} />
            <meta property="og:url" content={Constants.SITE_URL + "/contact-us"} />
            <meta property="og:title" content="Contact Augnito | Discover the Perfect Solution for Your Clinical Requirements" />
            <meta property="og:description" content="Get expert support for Augnito's medical speech to text software. Reach out for inquiries, or assistance with our AI-powered healthcare dictation solutions." />
            <meta property="og:image" content={Constants.SITE_URL + "/logo192.png"} />
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="en_US" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={Constants.SITE_URL + "/contact-us"}/>
            <meta name="twitter:site" content="@augnito" />
            <meta name="twitter:title" content="Contact Augnito | Discover the Perfect Solution for Your Clinical Requirements" />
            <meta name="twitter:description" content="Get expert support for Augnito's medical speech to text software. Reach out for inquiries, or assistance with our AI-powered healthcare dictation solutions." />
            <meta name="twitter:creator" content="@augnito" />
            <meta name="twitter:image" content={Constants.SITE_URL + "/logo192.png"} />
            <meta name="copyright" content="Augnito" />
            <meta name="owner" content="Augnito" />
            <link rel="alternate" href={Constants.SITE_URL} hreflang="en-us" />
            <meta name="google-site-verification" content="TivMeqLjfaI6TIRsSF0Kqw0J8UnBPK2PToomuQRwVCs" />
        </Helmet>
    );
};

export default ContactMeta;
